import React, { useEffect, useState, useRef } from "react";
import MetaTags from "react-meta-tags";
import { fabric } from "fabric";
import { v4 as uuidv4 } from 'uuid';
import { AvField, AvForm } from "availity-reactstrap-validation"
import Select from "react-select";
import location from "assets/images/location.png"
import { useDispatch, useSelector } from "react-redux"
import { appendData } from "store/Mode/actions"
import BaseService from "services/BaseService";
import { toast } from "react-toastify";

import {
    Container,
    Row,
    Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardImg

} from 'reactstrap'


const ImgModal = ({ img, index, setImages }) => {
    const [modal, setModal] = useState(false)
    const toggle = () => setModal(!modal)


    const addImagesHandler = (e) => {
        let files = e.target.files
        const filesData = Object.values(files)
        const uploadedImgs = []
        if (filesData.length) {
            Promise.all(
                filesData.map(async (file) => {
                    let res = await new BaseService().postUpload(file, {});
                    const createdFiles = { ...res.data.data, shapes: [] };
                    uploadedImgs.push(createdFiles)

                }),
            ).then(() => {
                setImages((images) => {
                    return images.map(imgData => {
                        if (imgData.id === img.id) {
                            return uploadedImgs[0]
                        } else {
                            return imgData
                        }
                    })
                })
                toggle()
            });
        }
    }


    return (
        <Col md={2} key={index} className="my-2 mx-3 p-0" style={{objectFit: "contain", height: "100px", borderRadius: "10px", overflow: "hidden" }}>
            <img
                onClick={toggle}
                src={img.path}
                style={{ objectFit: "cover",backgroundPosition:"" ,width: "100%", height: "100%", borderRadius: "10px", overflow: "hidden" }}
            />
            <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
                <ModalBody>
                    <Row className="my-1">
                        <Col md={6} className="font-size-16 fw-bold">
                            Edit Image
                        </Col>
                        <Col md={6}>
                            <span className="btn-hover d-flex flex-lg-row-reverse font-size-16 fw-bold" onClick={toggle}>x</span>
                        </Col>
                    </Row>
                    <hr />
                    <Row className="my-1">
                        <Col md={12} className="parent-div overflow-hidden " >
                            <CardImg className="position-relative" src={img ?.path} style={{ borderRadius: "10px" }}  >
                            </CardImg>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="mt-2 parent-div">
                            <button
                                type='button'
                                onClick={() => {

                                }}
                                className='btn btn-white w-100' style={{ border: "1px solid #555554" }}>
                                     <i className="fas fa-pen"></i> &nbsp;
                                Change
                    </button>
                    <input style={{
                        left: 0,
                        top: 0,
                        opacity: 0,
                        position: "absolute",
 

                     }} type="file" name="upfile" accept="image/*" onChange={addImagesHandler} />

                        </Col>
                        <Col md={6} className="mt-2">
                            <button
                                type='button'
                                onClick={() => {
                                    setImages(images => {
                                        return images.filter(imgData => imgData.id !== img.id)
                                    })
                                    toggle()
                                    toast.success("Image Deleted")

                                }}
                                className='btn btn-white  w-100' style={{ border: "1px solid #555554" }}>
                                     <i className="fas fa-trash-alt"></i>&nbsp; Remove
                            </button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </Col>

    )
}

export default ImgModal